import React from 'react'
import { useTranslation } from 'react-i18next'
import { OEmbed } from '~/models'
import { memo } from '~/ui/component'
import { Empty } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'
import ImageView from './ImageView'

export interface Props {
  embed: OEmbed
}

const EmbedView = memo('EmbedView', (props: Props) => {

  const [t] = useTranslation('misc')

  const {embed} = props

  const style = React.useMemo(() => {
    if (embed.type !== 'video' && embed.type !== 'rich') { return }

    if (typeof embed.width === 'number' && typeof embed.height === 'number') {
      return {
        height:        0,
        overflow:      'hidden',
        paddingBottom: `${embed.height / embed.width * 100}%`,
      }
    } else if (typeof embed.height === 'number') {
      return {
        height:       embed.height,
        overflow:     'visible',
        paddingBottom: 0,
      }
    } else {
      return
    }
  }, [embed])

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    if (embed.type !== 'video' && embed.type !== 'photo') {
      return renderError()
    }

    return (
      <div className={$.EmbedView} style={style}>
        {renderContent()}
      </div>
    )
  }

  function renderContent() {
    if (embed.type !== 'video' && embed.type !== 'photo') { return null }
    if (embed.type === 'video') {
      return (
        <div
          className={$.content}
          dangerouslySetInnerHTML={{__html: embed.html}}
        />
      )
    } else {
      return (
        <ImageView
          classNames={$.content}
          source={embed.url}
        />
      )
    }
  }

  function renderError() {
    return (
      <Empty
        {...t('embed:not-supported')}
        icon='error-full'
        flex
      />
    )
  }

  return render()

})

export default EmbedView

const useStyles = createUseStyles({
  EmbedView: {
    width: '100%',
    height: 0,
    overflow: 'hidden',
    paddingBottom: '56.25%',
    position: 'relative',
  },

  content: {
    ...layout.overlay,
    '& iframe': {
      width:  '100%',
      height: '100%',
    },
  },
})